import type { GlobalSearchResult, SearchByKey } from '../types/globalSearch';

const normalise = (value: string) => value.toLowerCase();

// Phone numbers match ignoring spaces, brackets and dashes
const digitsOnly = (value: string) => value.replace(/[^\d+]/g, '');

export function matchesSearch(result: GlobalSearchResult, query: string, searchBy: SearchByKey): boolean {
  const q = normalise(query.trim());
  if (!q) return false;
  const fieldEntries = Object.entries(result.fields) as [Exclude<SearchByKey, 'all'>, string][];
  const candidates = searchBy === 'all' ? fieldEntries : fieldEntries.filter(([key]) => key === searchBy);
  return candidates.some(([key, value]) => {
    if (key === 'phone' && digitsOnly(q).length >= 3) {
      return digitsOnly(value).includes(digitsOnly(q));
    }
    return normalise(value).includes(q);
  });
}

// Splits text into matched / unmatched parts for highlighting
export function splitMatch(text: string, query: string): {
  text: string;
  match: boolean;
}[] {
  const q = query.trim();
  if (!q) return [{
    text,
    match: false
  }];
  const lower = text.toLowerCase();
  const needle = q.toLowerCase();
  const parts: {
    text: string;
    match: boolean;
  }[] = [];
  let index = 0;
  while (index < text.length) {
    const found = lower.indexOf(needle, index);
    if (found === -1) {
      parts.push({
        text: text.slice(index),
        match: false
      });
      break;
    }
    if (found > index) parts.push({
      text: text.slice(index, found),
      match: false
    });
    parts.push({
      text: text.slice(found, found + needle.length),
      match: true
    });
    index = found + needle.length;
  }
  return parts;
}
